import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap; 
 
 const originalConsoleWarn = console.warn
 console.warn = (...args) => {
  if(typeof args[0] === 'string' && (args[0].includes('[Vue warn]') || args[0].includes('[Vue Router warn]: No match found for location'))){
   return
  }
  originalConsoleWarn.apply(console, args)
 }

// ---------------- Amount to Words ----------------
 function convertAmountToWords(amount) {
  if (isNaN(amount)) return "";

  const number = Math.floor(amount); // rupees
  const fraction = Math.round((amount - number) * 100); // paise

  let words = number > 0
    ? convertNumberToWords(number) + (number === 1 ? " rupee" : " rupees")
    : "zero rupees";

  if (fraction > 0) {
    words +=
      " and " +
      convertNumberToWords(fraction) +
      (fraction === 1 ? " paisa" : " paise");
  }

  return words.charAt(0).toUpperCase() + words.slice(1) + " only";
 }

 function convertNumberToWords(number) {
  const dictionary = {
    0: "zero", 1: "one", 2: "two", 3: "three", 4: "four", 5: "five",
    6: "six", 7: "seven", 8: "eight", 9: "nine", 10: "ten",
    11: "eleven", 12: "twelve", 13: "thirteen", 14: "fourteen", 15: "fifteen",
    16: "sixteen", 17: "seventeen", 18: "eighteen", 19: "nineteen",
    20: "twenty", 30: "thirty", 40: "forty", 50: "fifty",
    60: "sixty", 70: "seventy", 80: "eighty", 90: "ninety",
    100: "hundred", 1000: "thousand", 100000: "lakh", 10000000: "crore"
  };

  if (number === 0) return "";
  if (number < 0) return "negative " + convertNumberToWords(-number);

  if (number < 21) return dictionary[number];
  if (number < 100) {
    const tens = Math.floor(number / 10) * 10;
    const units = number % 10;
    return dictionary[tens] + (units ? "-" + dictionary[units] : "");
  }
  if (number < 1000) {
    const hundreds = Math.floor(number / 100);
    const remainder = number % 100;
    return (
      dictionary[hundreds] +
      " " +
      dictionary[100] +
      (remainder ? " and " + convertNumberToWords(remainder) : "")
    );
  }
  if (number < 100000) {
    const thousands = Math.floor(number / 1000);
    const remainder = number % 1000;
    return (
      convertNumberToWords(thousands) +
      " " +
      dictionary[1000] +
      (remainder ? ", " + convertNumberToWords(remainder) : "")
    );
  }
  if (number < 10000000) {
    const lakhs = Math.floor(number / 100000);
    const remainder = number % 100000;
    return (
      convertNumberToWords(lakhs) +
      " " +
      dictionary[100000] +
      (remainder ? ", " + convertNumberToWords(remainder) : "")
    );
  }

  // Crores
  const crores = Math.floor(number / 10000000);
  const remainder = number % 10000000;
  return (
    convertNumberToWords(crores) +
    " " +
    dictionary[10000000] +
    (remainder ? ", " + convertNumberToWords(remainder) : "")
  );
 }

// -------------------------------------------------

 
import { createApp } from 'vue';
import { router } from './router';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import App from "./App.vue";
import moment from 'moment';
import axios from '@/utils/axios';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import authMixin from './mixins/authMixin';
import NotificationMixin from './mixins/NotificationMixin'
import {BootstrapVue3, BToastPlugin} from 'bootstrap-vue-3'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import VueFeather from 'vue-feather';
import FlagIcon from 'vue-flag-icon';
import VueSweetalert2 from 'vue-sweetalert2' 
import 'sweetalert2/dist/sweetalert2.min.css'
import VueApexCharts from "vue3-apexcharts"; 
import StarRating from 'vue-star-rating'
import VueFormWizard from "vue3-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import VueSelect from 'vue3-select';
import 'vue3-select/dist/vue3-select.css';
import DatePicker from 'vue3-datepicker';
import VCalendar from 'v-calendar';
import ThemifyIcon from "vue-themify-icons";
import { IconHome } from '@tabler/icons-vue';
import Vue3TagsInput from "vue3-tags-input";
import VueEasyLightbox from "vue-easy-lightbox";
import CKEditor from '@ckeditor/ckeditor5-vue';
import SimpleLineIcons from "vue-simple-line";
import CircleProgress from "vue3-circle-progress";
import "vue3-circle-progress/dist/circle-progress.css";
import { Modal } from 'bootstrap'

/***********Layout Components **********/
import Layout_Header from '@/views/layouts/layout-header.vue';
import Layout_Sidebar from '@/views/layouts/layout-sidebar.vue';
import Horizontal_Header from '@/views/layouts/horizontal-header.vue';
import Two_Sidebar from '@/views/layouts/two-sidebar.vue';
import Stacked_Sidebar from '@/views/layouts/stacked-sidebar.vue';
import Theme_Settings from '@/views/layouts/theme-settings.vue';
import SidebarMenu from '@/views/layouts/sidebar-menu.vue';
import themeColor from '@/views/layouts/theme-color.vue';
import footer from '@/views/layouts/footer.vue';

/************Breadcrumb********************/

import indexBreadcrumb from '@/components/breadcrumb/index-breadcrumb.vue';


/************Page Components********************/

import NotesCarousel from "@/views/pages/applications/notes-carousel.vue";
import socialImage from '@/views/pages/applications/social-image.vue';
import socialCarousel from '@/views/pages/applications/social-carousel.vue';
import recentFile from '@/views/pages/applications/file-manager/recent-file.vue';
import recentFolder from '@/views/pages/applications/file-manager/recent-folder.vue';
import recentVideo from '@/views/pages/applications/file-manager/recent-video.vue';
import allKanban from '@/views/pages/applications/kanban-view/all-kanban.vue';
import highKanban from '@/views/pages/applications/kanban-view/high-kanban.vue';
import lowKanban from '@/views/pages/applications/kanban-view/low-kanban.vue';
import mediumKanban from '@/views/pages/applications/kanban-view/medium-kanban.vue';

import settingsTab from '@/views/pages/administration/settings/settings-tab.vue';
import generalSidebar from '@/views/pages/administration/settings/general-settings/general-sidebar.vue';
import websiteSidebar from '@/views/pages/administration/settings/website-settings/website-sidebar.vue';
import crmSidebar from '@/views/pages/administration/settings/crm-settings/crm-sidebar.vue';
import systemSidebar from '@/views/pages/administration/settings/system-settings/system-sidebar.vue';
import othersidebar from '@/views/pages/administration/settings/others-settings/others-sidebar.vue';
import appSidebar from '@/views/pages/administration/settings/app-settings/app-sidebar.vue';
import documentSidebar from '@/views/pages/administration/settings/document-settings/document-sidebar.vue';
import financialSidebar from '@/views/pages/administration/settings/financial-settings/financial-sidebar.vue';

import Inputsize from "@/views/pages/uiinterface/forms/form-elements/formbasic/input-size.vue";
import Form_Validation_One from '@/views/pages/uiinterface/forms/form-validation-one.vue'
import Carouselthree from "@/views/pages/uiinterface/baseui/carousel/carousel-three.vue";
import Carouseltwo from "@/views/pages/uiinterface/baseui/carousel/carousel-two.vue";
import Carouselone from "@/views/pages/uiinterface/baseui/carousel/carousel-one.vue";
import LightBoxOne from "@/views/pages/uiinterface/baseui/lightbox/lightbox-one.vue";
import LightBoxTwo from "@/views/pages/uiinterface/baseui/lightbox/lightbox-two.vue";

import rtlemployeeStatus from '@/views/pages/layout/layout-rtl/rtl-employee-status.vue';
import rtljobApplicants from '@/views/pages/layout/layout-rtl/rtl-job-applicants.vue';
import rtlprojectTable from '@/views/pages/layout/layout-rtl/rtl-project-table.vue';
import rtlsalesOverview from '@/views/pages/layout/layout-rtl/rtl-sales-overview.vue';
import rtlschedulesIndex from '@/views/pages/layout/layout-rtl/rtl-schedules-index.vue';
import rtlwelcomeWrap from '@/views/pages/layout/layout-rtl/rtl-welcome-wrap.vue';

import PackagesTable from '@/views/pages/superadmin/packages/packages-table.vue';
import DomainTable from '@/views/pages/superadmin/domain/domain-table.vue';
import PurchaseTable from '@/views/pages/superadmin/purchase/purchase-table.vue';
import ContactsTable from '@/views/pages/crm/contacts/contacts-table.vue';
import HolidaysTable from '@/views/pages/hrm/holidays/holidays-table.vue';
import LeavesAdminTable from '@/views/pages/hrm/attendance/leaves/leaves-admin-table.vue';
import LeavesEmployeeTable from '@/views/pages/hrm/attendance/leaves/leaves-employee-table.vue';
import AttendenceAdminTable from '@/views/pages/hrm/attendance/attendance-admin-table.vue';
import AttendanceEmployeeTable from '@/views/pages/hrm/attendance/attendance-employee-table.vue';
import TimesheetsTable from '@/views/pages/hrm/attendance/timesheets-table.vue';
import ScheduleTimeTable from '@/views/pages/hrm/attendance/schedule-time-table.vue';
import OvertimeTable from '@/views/pages/hrm/attendance/overtime-table.vue';
import IndicatorTable from '@/views/pages/hrm/attendance/performance/indicator-table.vue';
import ReviewTable from '@/views/pages/hrm/attendance/performance/review-table.vue';
import GoalTrackingTable from '@/views/pages/hrm/attendance/performance/goal-tracking-table.vue';
import GoalTypeTable from '@/views/pages/hrm/attendance/performance/goal-type-table.vue';
import TrainingTable from '@/views/pages/hrm/attendance/training/training-table.vue';
import TrainersTable from '@/views/pages/hrm/attendance/training/trainers-table.vue';
import TrainingTypeTable from '@/views/pages/hrm/attendance/training/training-type-table.vue';
import PromotionTable from '@/views/pages/hrm/promotion/promotion-table.vue';
import ResignationTable from '@/views/pages/hrm/resignation/resignation-table.vue';
import TerminationTable from '@/views/pages/hrm/termination/termination-table.vue';
import JobTable from '@/views/pages/recruitment/jobs/job-table.vue';
import CandidatesTable from '@/views/pages/recruitment/candidates/candidates-table.vue';
import CandidatesBoard from '@/views/pages/recruitment/candidates/candidates-board.vue';
import RefferalsTable from '@/views/pages/recruitment/refferals/refferals-table.vue';
import CategoriesTable from '@/views/pages/finance-accounts/accounting/categories-table.vue';
import PagesTable from '@/views/pages/content/pages-table.vue';
import CountriesTable from '@/views/pages/content/location/countries-table.vue';
import StatesTable from '@/views/pages/content/location/states-table.vue';
import CitiesTable from '@/views/pages/content/location/cities-table.vue';
import FaqTable from '@/views/pages/content/faq-table.vue';
import TaskBoardKanban from '@/views/pages/projects/task/task-board-kanban.vue';
import ExpensesReportTable from '@/views/pages/administration/reports/expenses-report-table.vue';
import InvoiceReportTable from '@/views/pages/administration/reports/invoice-report-table.vue';
import PaymentReportTable from '@/views/pages/administration/reports/payment-report-table.vue';
import ProjectReportTable from '@/views/pages/administration/reports/project-report-table.vue';
import TaskReportTable from '@/views/pages/administration/reports/task-report-table.vue';
import UserReportTable from '@/views/pages/administration/reports/user-report-table.vue';
import EmployeeReportTable from '@/views/pages/administration/reports/employee-report-table.vue';
import PayslipReportTable from '@/views/pages/administration/reports/payslip-report-table.vue';
import AttendanceReportTable from '@/views/pages/administration/reports/attendance-report-table.vue';
import LeaveReportTable from '@/views/pages/administration/reports/leave-report-table.vue';
import DailyReportTable from '@/views/pages/administration/reports/daily-report-table.vue';
import ProjectsImage from '@/views/pages/projects/project/projects-image.vue';
import SubscriptionTable from '@/views/pages/superadmin/subscription-table.vue';
import ProjectsTable from '@/views/pages/projects/project/projects-table.vue';
import clientTable from '@/views/pages/projects/clients/client-table.vue';



/************Modal********************/

import CallHistoryModal from '@/components/modal/call-history-modal.vue';
import calendarModal from '@/components/modal/calendar-modal.vue';
import companiesModal from '@/components/modal/companies-modal.vue';
import companiesDetailsModal from '@/components/modal/companies-details-modal.vue';
import customersModal from '@/components/modal/customers-modal.vue';
import clientsListModal from '@/components/modal/clients-list-modal.vue'
import clientsDetailsModal from '@/components/modal/clients-details-modal.vue';
import projectModal from '@/components/modal/project-modal.vue';
import projectDetailsModal from '@/components/modal/project-details-modal.vue';
import todoModal from '@/components/modal/todo-modal.vue';
import PurchaseModal from '@/components/modal/purchase-modal.vue';
import dealsGridModal from '@/components/modal/deals-grid-modal.vue';
import leadsModal from '@/components/modal/leads-modal.vue';
import BusinessCardModal from '@/views/pages/crm/business-cards/business-card-modal.vue'
import dealsDetailsModal from '@/components/modal/deals-details-modal.vue';
import TasksModal from '@/components/modal/tasks-modal.vue';
import ContactsModal from '@/components/modal/contacts-modal.vue';
import ContactDetailsModal from '@/components/modal/contact-details-modal.vue';
import employeeListModal from '@/components/modal/employee-list-modal.vue';
import employeeDetailsModal from '@/components/modal/employee-details-modal.vue';
import departmentModal from '@/components/modal/department-modal.vue';
import designationsModal from '@/components/modal/designations-modal.vue';
import ticketDetailsModal from '@/components/modal/ticket-details-modal.vue';
import ticketsModal from '@/components/modal/tickets-modal.vue';
import budgetsModal from '@/components/modal/budgets-modal.vue';
import budgetsExpenseModal from '@/components/modal/budgets-expense-modal.vue';
import budgetsRevenuesModal from '@/components/modal/budgets-revenues-modal.vue';
import employeeSalaryModal from '@/components/modal/employee-salary-modal.vue';
import payrollModal from '@/components/modal/payroll-modal.vue';
import payrollDeductionModal from '@/components/modal/payroll-deduction-modal.vue';
import payrollOvertimeModal from '@/components/modal/payroll-overtime-modal.vue';
import assetsModal from '@/components/modal/assets-modal.vue';
import rolesModal from '@/components/modal/roles-modal.vue';
import CompanyDetailsModal from '@/components/modal/company-details-modal.vue';
import PipelineModal from '@/components/modal/pipeline-modal.vue';
import ActivityModal from '@/components/modal/activity-modal.vue';
import HolidaysModal from '@/components/modal/holidays-modal.vue';
import LeavesAdminModal from '@/components/modal/leaves-admin-modal.vue';
import LeavesEmployeeModal from '@/components/modal/leaves-employee-modal.vue';
import LeaveSettingsModal from '@/components/modal/leave-settings-modal.vue';
import AttendenceAdminModal from '@/components/modal/attendance-admin-modal.vue';
import AttendanceEmployeeModal from '@/components/modal/attendance-employee-modal.vue';
import TimesheetsModal from '@/components/modal/timesheets-modal.vue';
import leaveTypeModal from '@/components/modal/leave-type-modal.vue';
import customFieldsModal from '@/components/modal/custom-fields-modal.vue';
import emailModal from '@/components/modal/email-modal.vue';
import smsTemplateModal from '@/components/modal/sms-template-modal.vue';
import smsSettingsModal from '@/components/modal/sms-settings-modal.vue';
import currenciesModal from '@/components/modal/currencies-modal.vue';
import banModal from '@/components/modal/ban-modal.vue';
import backupModal from '@/components/modal/backup-modal.vue';
import clearModal from '@/components/modal/clear-modal.vue';
import ScheduleTimeModal from '@/components/modal/schedule-time-modal.vue';
import OvertimeModal from '@/components/modal/overtime-modal.vue';
import IndicatorModal from '@/components/modal/indicator-modal.vue';
import PerformanceAppraisalModal from '@/components/modal/performance-appraisal-modal.vue';
import TechnicalTable from '@/components/modal/technical-table.vue';
import OrganizationalTable from '@/components/modal/organizational-table.vue';
import GoalTrackingModal from '@/components/modal/goal-tracking-modal.vue';
import GoalTypeModal from '@/components/modal/goal-type-modal.vue';
import TrainingModal from '@/components/modal/training-modal.vue';
import TrainersModal from '@/components/modal/trainers-modal.vue';
import TrainingTypeModal from '@/components/modal/training-type-modal.vue';
import PromotionModal from '@/components/modal/promotion-modal.vue';
import apiKeysModal from '@/components/modal/api-keys-modal.vue';
import todoListModal from '@/components/modal/todo-list-modal.vue';
import notesModal from '@/components/modal/notes-modal.vue';
import customersNotesModal from '@/components/modal/customers-notes-modal.vue';
import ResignationModal from '@/components/modal/resignation-modal.vue';
import TerminationModal from '@/components/modal/termination-modal.vue';
import JobGridModal from '@/components/modal/job-grid-modal.vue';
import JobListModal from '@/components/modal/job-list-modal.vue';
import CandidatesGridModal from '@/components/modal/candidates-grid-modal.vue';
import CandidatesModal from '@/components/modal/candidates-modal.vue';
import CandidatesKanbanModal from '@/components/modal/candidates-kanban-modal.vue';
import CategoriesModal from '@/components/modal/categories-modal.vue';
import PagesModal from '@/components/modal/pages-modal.vue';
import BlogsModal from '@/components/modal/blogs-modal.vue';
import ContriesModal from '@/components/modal/contries-modal.vue';

import ModuleModal from '@/components/modal/module-modal.vue';
import RolePermissionModal from '@/components/modal/role-permission-modal.vue';
import AdminModal from '@/components/modal/admin-modal.vue';
import SubAdminModal from '@/components/modal/subadmin-modal.vue';
import LeadStageModal from '@/components/modal/lead-stage-modal.vue';
import LeadSourceModal from '@/components/modal/lead-source-modal.vue';
import LeadAssignmentRuleModal from '@/components/modal/lead-assignment-rule-modal.vue';
import LeadAssignmentLocationRuleModal from '@/components/modal/lead-assignment-location-rule-modal.vue';
import ProjectPipelineModal from '@/components/modal/project-pipeline-modal.vue';
import ItemGroupModal from '@/components/modal/item-group-modal.vue';
import IndustryModal from '@/components/modal/industry-modal.vue';
import KnowledgeBaseCategoryModal from '@/components/modal/knowledge-base-category-modal.vue';
import KnowledgeBaseModal from '@/components/modal/knowledge-base-modal.vue';
import DocumentTemplateModal from '@/components/modal/document-template-modal.vue';
import TaxModal from '@/components/modal/tax-modal.vue';
import ChartModal from '@/components/modal/chart-modal.vue';
import ItemModal from '@/components/modal/item-modal.vue';
import ProposalModal from '@/components/modal/proposal-modal.vue';
import QuotationModal from '@/components/modal/quotation-modal.vue';
import InvoiceModal from '@/components/modal/invoice-modal.vue';
import ProformaInvoiceModal from '@/components/modal/proforma-invoice-modal.vue';
import CustomerDispatchModal from '@/components/modal/customer-dispatch-modal.vue';

// #############################################################################
//          ************************ CPQ ********************
// #############################################################################

import ItemOptionModal from '@/components/modal/item-option-modal.vue';
import ItemOptionValueModal from '@/components/modal/item-option-value-modal.vue';

// #############################################################################
//          ************************ INVENTORY ********************
// #############################################################################
import vendorModal from '@/components/modal/vendor-modal.vue';
import warehouseModal from '@/components/modal/warehouse-modal.vue';
import purchaseOrderModal from '@/components/modal/purchase-order-modal.vue';
import deliveryChallanModal from '@/components/modal/delivery-challan-modal.vue';
import PendingItemsModal from '@/components/modal/pending-items-modal.vue';
import WorkOrderModal from '@/components/modal/work-order-modal.vue';
import DeliveryChallanReturnModal from '@/components/modal/delivery-challan-return-modal.vue';
import ProductionModal from '@/components/modal/ProductionModal.vue';
import BankModal from '@/components/modal/bank-modal.vue';
import BranchModal from '@/components/modal/branch-modal.vue';
import AppStoreModal from '@/components/modal/app-store-modal.vue';
import UserReportModal from '@/components/modal/user-report-modal.vue';
import LeadReportModal from '@/components/modal/lead-report-modal.vue';
import ReminderModal from '@/components/modal/reminder-modal.vue';

import PaymentModal from '@/components/modal/payment-modal.vue';

import SamplingModal from '@/components/modal/sampling-modal.vue';
import SalesOrderModal from '@/components/modal/sales-order-modal.vue';

import SubscriptionModal from '@/components/modal/subscription-modal.vue';

import PaymentLinkModal from '@/components/modal/payment-link-modal.vue';


// #############################################################################
//          ************************ HRMS ********************
// #############################################################################

import HrmDepartmentModal from '@/components/modal/hrm-department-modal.vue';
import HrmPositionModal from '@/components/modal/hrm-position-modal.vue';
import hrmShiftModal from '@/components/modal/hrm-shift-modal.vue';
import HrmHolidayModal from '@/components/modal/hrm-holiday-modal.vue';
import HrmLeaveTypeModal from '@/components/modal/hrm-leave-type-modal.vue';
import HrmLeavePolicyModal from '@/components/modal/hrm-leave-policy-modal.vue';
import HrmSalaryComponentModal from '@/components/modal/hrm-salary-component-modal.vue';
import HrmSalaryStructureModal from '@/components/modal/hrm-salary-structure-modal.vue';
import HrmStructureComponentsModal from '@/components/modal/hrm-structure-components-modal.vue';
import HrmAttendancePolicyModal from '@/components/modal/hrm-attendance-policy-modal.vue';
import HrmEmployeeSalaryModal from '@/components/modal/hrm-employee-salary-modal.vue';
import HrmEmployeeSalaryHistoryModal from '@/components/modal/hrm-employee-salary-history-modal.vue';
import HrmAttendanceManualModal from '@/components/modal/hrm-attendance-manual-modal.vue';
import HrmRegularizationCreateModal from '@/components/modal/hrm-regularization-create-modal.vue';
import HrmPunchWidget from '@/components/modal/hrm-punch-widget.vue';
import HrmAnnouncementModal from '@/components/modal/hrm-announcement-modal.vue';
import HrmAnnouncementStatsModal from '@/components/modal/hrm-announcement-stats-modal.vue';
import HrmAnnouncementViewModal from '@/components/modal/hrm-announcement-view-modal.vue';
import HrmDocumentModal from '@/components/modal/hrm-document-modal.vue';
import HrmAssetCategoryModal from '@/components/modal/hrm-asset-category-modal.vue';
import HrmDocumentAssignModal from '@/components/modal/hrm-document-assign-modal.vue';
import HrmAssetModal from '@/components/modal/hrm-asset-modal.vue';
import HrmAssetAssignModal from '@/components/modal/hrm-asset-assign-modal.vue';
import HrmAssetReturnModal from '@/components/modal/hrm-asset-return-modal.vue';


import StatesModal from '@/components/modal/states-modal.vue';
import CitiesModal from '@/components/modal/cities-modal.vue';
import FaqModal from '@/components/modal/faq-modal.vue';
import policyModal from '@/components/modal/policy-modal.vue';
import adminDashboardModal from '@/components/modal/admin-dashboard-modal.vue';
import employeeDashboardModal from '@/components/modal/employee-dashboard-modal.vue';
import PackagesModal from '@/components/modal/packages-modal.vue';
import DomainModal from '@/components/modal/domain-modal.vue';
import fileManagerModal from '@/components/modal/file-manager-modal.vue';
import blogsTagsModal from '@/components/modal/blogs-tags-modal.vue';
import cronjobScheduleModal from '@/components/modal/cronjob-schedule-modal.vue';
import userListModal from '@/components/modal/user-list-modal.vue';
import AppSkeleton from '@/components/common/AppSkeleton.vue';
import AppTable from '@/components/common/AppTable.vue';
import AgentChatWidget from '@/components/common/AgentChatWidget.vue';
import PincodeInput from '@/components/common/PincodeInput.vue';

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'ionicons-npm/css/ionicons.css';
import 'material-icons/css/material-icons.min.css';
import 'material-icons/css/material-icons.css';
import 'pe7-icon/dist/dist/pe-icon-7-stroke.css';
import 'typicons.font/src/font/typicons.css';
import 'weathericons/css/weather-icons.css'
import '@/assets/css/feather.css'
import '@/assets/css/sticky.css'
import '@/assets/css/tabler-icons.css'
import '@/assets/css/vue-form-wizard.css';
import "boxicons/css/boxicons.min.css";
import "v-calendar/dist/style.css";
import '@/assets/scss/main.scss'
import '@/assets/css/custom.css';

import swal from 'sweetalert2';
window.Swal = swal;

const app = createApp(App)
/*Global Components */

app.mixin(authMixin);
app.mixin(NotificationMixin);

/*************Layout *****************/
app.component('layout-header',Layout_Header)
app.component('layout-sidebar',Layout_Sidebar)
app.component('horizontal-header',Horizontal_Header)
app.component('two-sidebar',Two_Sidebar)
app.component('stacked-sidebar',Stacked_Sidebar)
app.component('theme-settings',Theme_Settings)
app.component('sidebar-menu', SidebarMenu)
app.component('theme-color', themeColor)
app.component('app-footer', footer)

/*************Breadcrumb *****************/
app.component('breadcrumb',indexBreadcrumb)


/*************Skeleton ********************/
app.component('app-skeleton', AppSkeleton);

/************* table  ************************/  
app.component('app-table', AppTable);
app.component('agent-chat-widget', AgentChatWidget);
app.component('pincode-input', PincodeInput);

/************Page Components********************/
app.component('all-kanban',allKanban)
app.component('high-kanban',highKanban)
app.component('low-kanban',lowKanban)
app.component('medium-kanban',mediumKanban)

app.component('general-sidebar',generalSidebar)
app.component('website-sidebar',websiteSidebar)
app.component('crm-sidebar',crmSidebar)
app.component('system-sidebar',systemSidebar)
app.component('others-sidebar',othersidebar)
app.component('app-sidebar',appSidebar);
app.component('document-sidebar', documentSidebar);
app.component('financial-sidebar',financialSidebar)
app.component('settings-tab',settingsTab)

app.component('packages-table', PackagesTable)
app.component('domain-table', DomainTable)
app.component('purchase-table', PurchaseTable)
app.component('contacts-table', ContactsTable)
app.component('holidays-table', HolidaysTable)
app.component('leaves-admin-table', LeavesAdminTable)
app.component('leaves-employee-table', LeavesEmployeeTable)
app.component('attendence-admin-table', AttendenceAdminTable)
app.component('attendence-employee-table', AttendanceEmployeeTable)
app.component('timesheets-table', TimesheetsTable)
app.component('schedule-time-table', ScheduleTimeTable)
app.component('overtime-table', OvertimeTable)
app.component('indicator-table', IndicatorTable)
app.component('review-table', ReviewTable)
app.component('goal-tracking-table', GoalTrackingTable)
app.component('goal-type-table', GoalTypeTable)
app.component('trining-table', TrainingTable)
app.component('trainers-table', TrainersTable)
app.component('training-type-table', TrainingTypeTable)
app.component('promotion-table', PromotionTable)
app.component("notes-carousel", NotesCarousel);
app.component('social-image',socialImage)
app.component('social-carousel',socialCarousel)
app.component('recent-file',recentFile)
app.component('recent-folder',recentFolder)
app.component('recent-video',recentVideo)
app.component('resignation-table', ResignationTable)
app.component('termination-table', TerminationTable)
app.component('job-table', JobTable)
app.component('candidates-table', CandidatesTable)
app.component('candidates-board', CandidatesBoard)
app.component('refferals-table', RefferalsTable)
app.component('categories-table', CategoriesTable)
app.component('pages-table', PagesTable)
app.component('countries-table', CountriesTable)
app.component('states-table', StatesTable)
app.component('cities-table', CitiesTable)
app.component('faq-table', FaqTable)
app.component('task-board-kanban', TaskBoardKanban)
app.component('expenses-report-table', ExpensesReportTable)
app.component('invoice-report-table', InvoiceReportTable)
app.component('payment-report-table', PaymentReportTable)
app.component('project-report-table', ProjectReportTable)
app.component('task-report-table', TaskReportTable)
app.component('user-report-table', UserReportTable)
app.component('employee-report-table', EmployeeReportTable)
app.component('payslip-report-table', PayslipReportTable)
app.component('attendance-report-table', AttendanceReportTable)
app.component('leave-report-table', LeaveReportTable)
app.component('daily-report-table', DailyReportTable)
app.component('projects-image', ProjectsImage)
app.component('subscription-table', SubscriptionTable)
app.component('projects-table', ProjectsTable)
app.component('client-table', clientTable)


app.component('rtl-welcome-wrap',rtlwelcomeWrap)
app.component('rtl-schedules-index',rtlschedulesIndex)
app.component('rtl-sales-overview',rtlsalesOverview)
app.component('rtl-project-table',rtlprojectTable)
app.component('rtl-job-applicants',rtljobApplicants)
app.component('rtl-employee-status',rtlemployeeStatus)

app.component("input-size", Inputsize);
app.component('form-validation-one',Form_Validation_One)
app.component("carousel-one", Carouselone);
app.component("carousel-two", Carouseltwo);
app.component("carousel-three", Carouselthree);
app.component("lightbox-one", LightBoxOne);
app.component("lightbox-two", LightBoxTwo);

/************Page Filter********************/


/************Modal********************/
app.component('call-history-modal',CallHistoryModal)
app.component('calendar-modal',calendarModal)
app.component('companies-modal',companiesModal)
app.component('companies-details-modal',companiesDetailsModal)
app.component('customers-modal',customersModal)
app.component('clients-list-modal',clientsListModal)
app.component('clients-details-modal',clientsDetailsModal)
app.component('project-modal',projectModal)
app.component('project-details-modal',projectDetailsModal)
app.component('todo-modal',todoModal)
app.component('deals-grid-modal',dealsGridModal)
app.component('deals-details-modal',dealsDetailsModal)
app.component('purchase-modal', PurchaseModal)
app.component('tasks-modal', TasksModal)
app.component('contacts-modal', ContactsModal)
app.component('contact-details-modal', ContactDetailsModal)
app.component('employee-list-modal',employeeListModal)
app.component('employee-details-modal',employeeDetailsModal)
app.component('department-modal',departmentModal)
app.component('designations-modal',designationsModal)
app.component('ticket-details-modal',ticketDetailsModal)
app.component('tickets-modal',ticketsModal)
app.component('budgets-modal',budgetsModal)
app.component('budgets-expense-modal',budgetsExpenseModal)
app.component('budgets-revenues-modal',budgetsRevenuesModal)
app.component('employee-salary-modal',employeeSalaryModal)
app.component('payroll-modal',payrollModal)
app.component('payroll-deduction-modal',payrollDeductionModal)
app.component('payroll-overtime-modal',payrollOvertimeModal)
app.component('assets-modal',assetsModal)
app.component('roles-modal',rolesModal)
app.component('company-details-modal', CompanyDetailsModal)
app.component('pipeline-modal', PipelineModal)
app.component('activity-modal', ActivityModal)
app.component('holidays-modal', HolidaysModal)
app.component('leaves-admin-modal', LeavesAdminModal)
app.component('leaves-employee-modal', LeavesEmployeeModal)
app.component('leave-settings-modal', LeaveSettingsModal)
app.component('attendence-admin-modal', AttendenceAdminModal)
app.component('attendance-employee-modal', AttendanceEmployeeModal)
app.component('timesheets-modal', TimesheetsModal)
app.component('leave-type-modal', leaveTypeModal)
app.component('custom-fields-modal',customFieldsModal)
app.component('email-modal',emailModal)
app.component('sms-template-modal',smsTemplateModal)
app.component('sms-settings-modal',smsSettingsModal)
app.component('currencies-modal',currenciesModal)
app.component('ban-modal',banModal)
app.component('backup-modal',backupModal)
app.component('clear-modal',clearModal)
app.component('schedule-time-modal', ScheduleTimeModal)
app.component('overtime-modal', OvertimeModal)
app.component('indicator-modal', IndicatorModal)
app.component('performance-appraisal-modal', PerformanceAppraisalModal)
app.component('technical-table', TechnicalTable)
app.component('organizational-table', OrganizationalTable)
app.component('goal-tracking-modal', GoalTrackingModal)
app.component('goal-type-modal', GoalTypeModal)
app.component('training-modal', TrainingModal)
app.component('trainers-modal', TrainersModal)
app.component('training-type-modal', TrainingTypeModal)
app.component('promotion-modal', PromotionModal)
app.component('api-keys-modal',apiKeysModal)
app.component('todo-list-modal',todoListModal)
app.component('notes-modal',notesModal)
app.component('customers-notes-modal',customersNotesModal)
app.component('resignation-modal', ResignationModal)
app.component('termination-modal', TerminationModal)
app.component('job-grid-modal', JobGridModal)
app.component('job-list-modal', JobListModal)
app.component('candidates-grid-modal', CandidatesGridModal)
app.component('candidates-modal', CandidatesModal)
app.component('candidates-kanban-modal', CandidatesKanbanModal)
app.component('categories-modal', CategoriesModal)
app.component('pages-modal', PagesModal)
app.component('blogs-modal', BlogsModal)
app.component('countries-modal', ContriesModal)
//CUSTOM MODALS
app.component('module-modal', ModuleModal)
app.component('role-permission-modal', RolePermissionModal)
app.component('admin-modal', AdminModal)
app.component('subadmin-modal', SubAdminModal)
app.component('lead-stage-modal', LeadStageModal)
app.component('project-pipeline-modal', ProjectPipelineModal)
app.component('lead-source-modal', LeadSourceModal)
app.component('lead-assignment-rule-modal', LeadAssignmentRuleModal)
app.component('lead-assignment-location-rule-modal', LeadAssignmentLocationRuleModal);
app.component('item-group-modal', ItemGroupModal)
app.component('industry-modal', IndustryModal)
app.component('knowledge-base-category-modal', KnowledgeBaseCategoryModal)
app.component('knowledge-base-modal', KnowledgeBaseModal)
app.component('document-template-modal', DocumentTemplateModal)
app.component('tax-modal', TaxModal)
app.component('chart-modal', ChartModal)
app.component('item-modal', ItemModal)
app.component('leads-modal',leadsModal)
app.component('business-card-modal', BusinessCardModal)
app.component('bank-modal', BankModal)
app.component('branch-modal', BranchModal)
app.component('app-store-modal', AppStoreModal)
app.component('user-report-modal', UserReportModal)
app.component('lead-report-modal', LeadReportModal)
app.component('reminder-modal', ReminderModal)
app.component('payment-modal', PaymentModal)
app.component('sampling-modal', SamplingModal)
app.component('sales-order-modal', SalesOrderModal)
app.component('subscription-modal', SubscriptionModal)
app.component('payment-link-modal', PaymentLinkModal)
app.component('proposal-modal', ProposalModal)
app.component('quotation-modal', QuotationModal)
app.component('invoice-modal', InvoiceModal)
app.component('proforma-invoice-modal', ProformaInvoiceModal)
app.component('customer-dispatch-modal', CustomerDispatchModal);

// #############################################################################
//         ************************ CPQ ********************
// #############################################################################

app.component('item-option-modal', ItemOptionModal);
app.component('item-option-value-modal', ItemOptionValueModal);

// #############################################################################
//         ************************ INVENTORY ********************
// #############################################################################
app.component('vendor-modal', vendorModal)
app.component('warehouse-modal', warehouseModal)
app.component('purchase-order-modal', purchaseOrderModal);
app.component('delivery-challan-modal', deliveryChallanModal);
app.component('pending-items-modal', PendingItemsModal);
app.component('work-order-modal', WorkOrderModal);
app.component('delivery-challan-return-modal', DeliveryChallanReturnModal);
app.component('production-modal', ProductionModal);
app.component('states-modal', StatesModal)
app.component('cities-modal', CitiesModal)
app.component('faq-modal', FaqModal)
app.component('policy-modal', policyModal)
app.component('admin-dashboard-modal', adminDashboardModal)
app.component('employee-dashboard-modal', employeeDashboardModal)
app.component('packages-modal', PackagesModal) 
app.component('domain-modal', DomainModal)
app.component('file-manager-modal', fileManagerModal)
app.component('blogs-tags-modal', blogsTagsModal)
app.component('cronjob-schedule-modal', cronjobScheduleModal)
app.component('user-list-modal', userListModal)


// #############################################################################
//         ************************ HRMS ********************
// #############################################################################

app.component('hrm-department-modal', HrmDepartmentModal);
app.component('hrm-position-modal', HrmPositionModal);
app.component('hrm-shift-modal', hrmShiftModal);
app.component('hrm-holiday-modal', HrmHolidayModal);
app.component('hrm-leave-type-modal', HrmLeaveTypeModal);
app.component('hrm-leave-policy-modal', HrmLeavePolicyModal);
app.component('hrm-salary-component-modal', HrmSalaryComponentModal);
app.component('hrm-salary-structure-modal', HrmSalaryStructureModal);
app.component('hrm-structure-components-modal', HrmStructureComponentsModal);
app.component('hrm-attendance-policy-modal', HrmAttendancePolicyModal);
app.component('hrm-employee-salary-modal', HrmEmployeeSalaryModal);
app.component('hrm-employee-salary-history-modal', HrmEmployeeSalaryHistoryModal);
app.component('hrm-attendance-manual-modal', HrmAttendanceManualModal);
app.component('hrm-regularization-create-modal', HrmRegularizationCreateModal);
app.component('hrm-punch-widget', HrmPunchWidget);
app.component('hrm-announcement-modal', HrmAnnouncementModal);
app.component('hrm-announcement-stats-modal', HrmAnnouncementStatsModal);
app.component('hrm-announcement-view-modal', HrmAnnouncementViewModal);
app.component('hrm-document-modal', HrmDocumentModal);
app.component('hrm-asset-category-modal', HrmAssetCategoryModal);
app.component('hrm-document-assign-modal', HrmDocumentAssignModal);
app.component('hrm-asset-modal', HrmAssetModal);
app.component('hrm-asset-assign-modal', HrmAssetAssignModal);
app.component('hrm-asset-return-modal', HrmAssetReturnModal);


app.component('vue-select', VueSelect);
app.component(VueFeather.name, VueFeather)
app.use(Toast)

app.use(VueSweetalert2)
app.use(VueApexCharts)
app.component('star-rating', StarRating)
app.component('circle-progress',CircleProgress)
app.component('date-picker', DatePicker);
app.component('vue3-tags-input', Vue3TagsInput);
app.use(FlagIcon)
.use(Antd)
.use(VueEasyLightbox)
.use(VueFormWizard)
app.use(VCalendar)
.use(BootstrapVue3)
.use(BToastPlugin)
  .use(ThemifyIcon)
  .use(SimpleLineIcons)
app.component('IconHome', IconHome);
app.use(CKEditor);

app.config.globalProperties.$formatDate = (date, format = 'DD-MM-YYYY') => {
  return moment(date).format(format);
};

app.config.globalProperties.$fromNow = (date) => {
  return moment(date).fromNow();
};

app.config.globalProperties.$timeStamp = () => {
  const now = new Date();
  const pad = n => n.toString().padStart(2, '0');
  return (
    now.getFullYear() +
    pad(now.getMonth() + 1) +
    pad(now.getDate()) + '_' +
    pad(now.getHours()) +
    pad(now.getMinutes()) +
    pad(now.getSeconds())
  );
};

app.config.globalProperties.$currentDate = (daysToAdd = 0) => {
 const today = new Date();
 today.setDate(today.getDate() + daysToAdd);
 const day = String(today.getDate()).padStart(2, '0');
 const month = String(today.getMonth() + 1).padStart(2, '0');
 const year = today.getFullYear();
 return `${year}-${month}-${day}`;
};

app.config.globalProperties.$profileImage = (imageName, clientAdmin) => {
 if(imageName){
  return `${process.env.VUE_APP_IMAGE_PATH}/users/${clientAdmin?.id}/${imageName}`;
 }
 return require('@/assets/img/profiles/avatar-12.jpg');
};

app.config.globalProperties.$clientLogo = (imageName, clientAdmin) => {
 if(imageName){
  return `${process.env.VUE_APP_IMAGE_PATH}/users/${clientAdmin?.id}/${imageName}`;
 }
 return require('@/assets/img/logo.webp');
};

app.config.globalProperties.$clientSignature = (imageName, clientAdmin) => {
 if(imageName){
  return `${process.env.VUE_APP_IMAGE_PATH}/users/${clientAdmin?.id}/${imageName}`;
 }
 return null;
};

app.config.globalProperties.$clientImage = (imageName, folder, clientAdmin) => {
 if(imageName){
  return `${process.env.VUE_APP_IMAGE_PATH}/${folder}/${clientAdmin?.id}/${imageName}`;
 }
 return require('@/assets/img/profiles/avatar-01.jpg');;
};

app.config.globalProperties.$projectDocument = (imageName, clientAdmin) => {
 if(imageName){
  return `${process.env.VUE_APP_IMAGE_PATH}/project_documents/${clientAdmin?.id}/${imageName}`;
 }
 return null;
};

app.config.globalProperties.$numFormat = (number) => {
 number = parseInt(String(number).replace(/[^0-9]/g, ''), 10);
 if(number >= 1000){
  const units = ['K', 'M', 'B', 'T', 'Q'];
  const digits = Math.floor(("" + number).length / 3);
  const divisor = Math.pow(1000, digits);
  let shortValue = number / divisor;
  shortValue = shortValue.toFixed(1).replace(/\.0$/, '');
  return shortValue + units[digits - 1];
 }
 return String(number);
};

app.config.globalProperties.$confirm = (options = {}) => {
 const defaultOptions = {
  title: "Are you sure?",
  text: "You won't be able to revert this!",
  icon: "warning",
  showCancelButton: true,
  confirmButtonColor: "#3085d6",
  cancelButtonColor: "#d33",
  confirmButtonText: "Yes, do it!",
 };
 return Swal.fire({ ...defaultOptions, ...options });
};

app.config.globalProperties.$toggleAll = (event, data, key = 'id') => {
 if(event.target.checked){
  return data.map(row => row[key]);
 }else{
  return [];
 }  
};

app.config.globalProperties.$copyText = (text) => {
 navigator.clipboard.writeText(text);
 app.config.globalProperties.$swalToast('Copied.');
}

app.config.globalProperties.$swalToast = (text, type = 'success', duration = 2500) => {
 Swal.fire({
  icon: type,
  title: text,
  toast: true,
  timer: duration,
  position: 'top-end',
  showConfirmButton: false
 });
}

app.config.globalProperties.$partyURL = (party_id, party_type) => {
 if(party_type === "App\\Models\\Lead"){
  return `/crm/leads-details/${party_id}`;
 }
 if(party_type === "App\\Models\\Customer"){
  return `/crm/customers-details/${party_id}`;
 }
 return "#";
},

app.config.globalProperties.$appCurrency = async () => {
 try{
  const response  = await axios.get(`/currencies/default`);
  return response.data.data;
 }catch(error){
  console.log(error.message);
 }
};

app.config.globalProperties.$leadConversionLabel = () => {
 return `<i class="ti ti-check me-1"></i>Converted`;
};

app.config.globalProperties.$firstLetter = (str) =>{
 return typeof str === 'string' && str.length > 0 ? str[0].toUpperCase() : ''; 
}

app.config.globalProperties.$superAdminImage = (imageName, folder) => {
 if(imageName){
  return `${process.env.VUE_APP_IMAGE_PATH}/${folder}/${imageName}`;
 }
 return require('@/assets/img/profiles/avatar-01.jpg');;
};

app.config.globalProperties.$openModal = function(modalId) {
 const modalEl = document.getElementById(modalId);
 const modal = Modal.getInstance(modalEl);
 if(modal){
  modal.show();
 }else{
  new Modal(modalEl).show();
 }
};

app.config.globalProperties.$closeModal = function(modalId) {
 const modalEl = document.getElementById(modalId);
 const modal = Modal.getInstance(modalEl);
 if(modal){
  modal.hide();
 }
};

app.config.globalProperties.$amountInWords = convertAmountToWords;

document.addEventListener('show.bs.dropdown', function(e) {
    const menu = e.target.closest('.dropdown').querySelector('.dropdown-menu');
    const btn = e.target;
    const rect = btn.getBoundingClientRect();
    const menuHeight = menu.offsetHeight || 300;
    const spaceBelow = window.innerHeight - rect.bottom;
    
    setTimeout(() => {
        menu.style.setProperty('position', 'fixed', 'important');
        menu.style.setProperty('transform', 'none', 'important');
        menu.style.setProperty('inset', 'unset', 'important');
        menu.style.setProperty('right', (window.innerWidth - rect.right) + 'px', 'important');
        menu.style.setProperty('left', 'auto', 'important');
        
        if(spaceBelow < menuHeight){
            menu.style.setProperty('top', 'auto', 'important');
            menu.style.setProperty('bottom', (window.innerHeight - rect.top + 5) + 'px', 'important');
        } else {
            menu.style.setProperty('top', (rect.bottom + 5) + 'px', 'important');
            menu.style.setProperty('bottom', 'auto', 'important');
        }
    }, 0);
});

document.addEventListener('scroll', function(e) {
    const openDropdown = document.querySelector('.dropdown-menu.show');
    if(openDropdown){
        if(openDropdown.contains(e.target) || openDropdown === e.target) return;
        const dropdownBtn = openDropdown.closest('.dropdown').querySelector('[data-bs-toggle="dropdown"]');
        if(dropdownBtn){
            bootstrap.Dropdown.getInstance(dropdownBtn)?.hide();
        }
    }
}, true);

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(pinia).use(router).mount('#app') 

